// QUOTE SLIDER
const quoteSliderSections = document.querySelectorAll('.o-sec.quote-slider');
if(quoteSliderSections.length > 0) {
  quoteSliderSections.forEach(function(sliderSection) {
    const slider = sliderSection.querySelector('.c-slider');
    const sliderNextArrow = sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.next');
    const sliderPrevArrow = sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.prev');
    
    const quoteSlider = new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: sliderNextArrow,
        prevEl: sliderPrevArrow,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1200
    });

    quoteSlider.on('slideChange', function(swiper) {
      const currentSlideIndex = swiper.realIndex;        
      const sliderBullets = sliderSection.querySelectorAll('.c-slider-bullet');
      sliderBullets.forEach(function(bullet, index) {
        if( index === currentSlideIndex ) {
          bullet.classList.add('active');
        } else {
          bullet.classList.remove('active');
        }
      });
    });
  });
}